import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import UpcomingReviewsSource from 'sources/coaching/UpcomingReviewsSource';

const REVIEW_COUNT_TO_FETCH = 100;
export const REVIEW_COUNT_FOR_SIDEBAR = 3;

class UpcomingReviewsActions {
  constructor() {
    this.generateActions(...generateAsyncActions('upcomingReviews', 'sendReminder'));
  }

  /**
   * Gather upcoming reviews for the currently logged in user.
   *
   * Managers will receive results where they are the coaching participant, and reps
   * will receive results where they are the recipient.
   *
   * Supports pagination.
   *
   * @param userId - user to grab upcoming reviews for
   * @param role - coach, participant, or both
   * @param from - start index
   * @param size - how many to grab
   * @param reviewId - optional specific review id to return in addition to the ones specified
   * @param teamId - optional specific team id, for the "coach" role only, used to restrict the coach's
   * reviews to members of that team
   * @returns (d) => Promise - action creator to return list of upcoming reviews
   */
  upcomingReviews(userId, role, from = 0, size = REVIEW_COUNT_TO_FETCH, reviewId, teamId) {
    return dispatch => {
      dispatch();
      return UpcomingReviewsSource.upcomingReviews(userId, role, from, size, reviewId, teamId).then(
        reviews => this.upcomingReviewsSuccess(userId, reviews),
        this.upcomingReviewsError
      );
    };
  }

  sendReminder(userId, reviewId) {
    return dispatch => {
      dispatch();
      return UpcomingReviewsSource.sendReminder(reviewId).then(
        review => this.sendReminderSuccess(userId, review),
        e => {
          this.sendReminderError(e);
          throw e;
        }
      );
    };
  }
}

export default alt.createActions(UpcomingReviewsActions);
